import { useEffect, useState } from "react"
import { SBAComboBox } from "../../../UiComponents/SBADropDown"
import { sbaAxios } from "../../../utils/sbaAxios";
import { DeleteAssetMapping, GetAnalystTypes, GetAssetMappings, GetRawByAsset, InsertUpdateAssetMapping, getPrivateExposureAssetList } from "../../../../config/apiConfig";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { SBNotify } from "../../../utils/sbNotify";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { useDispatch, useSelector } from "react-redux";
import { UrlPath } from "../../../../config/routeConfig";
import { getAsset } from "../../../actions/assetAction";

export const Mapping = () => {
  const params = useParams();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [analystType, setAnalystType] = useState([]);
  const [rawByAsset, setRawByAsset] = useState([]);
  const [assetMappings, setAssetMappings] = useState([]);
  const [AssetListData, setAssetListData] = useState([]);


  const [mappingDrawer,setMappingDrawer]=useState(false);
  const [selectedMapping,setSelectedMapping]=useState({
    AssetExposureMappingId: 0,
    AssetId: 0,
    AnalystExposureId: 0,
    RawExposureId: 0,
    ExposureWeight: 0,
    ModifiedBy: 0
  });
  const Gstate = useSelector((state) => {
    return state;}) || {};
  const currentAsset = Gstate.asset.asset || {};
  useEffect(()=>{
    dispatch(getAsset(params.Asset));
    // fetchAnalystTypes();
    fetchRaw(params.Asset);
    fetchAssetMapping(params.Asset);
  },[params.Asset]);
  const AssestDDChanged = (e) => {
    if(e.value)
    {
      history(`${UrlPath.PrivateExposure}${e.value.AssetId}`);
    }
  };
  const fetchAnalystTypes = async () => {
    const analystType = await getAnalystTypes();
    setAnalystType(() => analystType.map(item=>({
      AnalystExposureId:item.ExposureId,
      AnalystExposure:item.ExposureName,
    })));
  };
  const fetchRaw = async (assetID) => {
    const rawData = await getRawByAsset(assetID);
    setRawByAsset(() => rawData.map(item=>({
      RawExposureId:item.ExposureId,
      RawExposure:item.ExposureName,
    })));
  };
  const fetchAssetMapping = async (assetID) => {
    const rawData = await getAssetMappings(assetID);
    setAssetMappings(() => rawData);
  };
  const assetListData = async () => {
    try {
      const response = await sbaAxios({
        url: `${getPrivateExposureAssetList}`,
        method: "get",
      });
      const data = response;
      setAssetListData(data);
    } catch (error) {
      console.error("Error fetching assetListData from API:", error);
    }
    };
  useEffect(() => {
    fetchAnalystTypes();
    assetListData();
    document.title="Exposure";
  }, []);

  const getAnalystTypes = async () => {
    try {
      return await sbaAxios({ url: GetAnalystTypes });
    } catch (error) {
      console.error("Error Occurred While Fetching Analyst data", error);
      return [];
    }
  };
  const getRawByAsset = async (assetId) => {
    try {
      return await sbaAxios({ url: GetRawByAsset + "?assetId=" + assetId })
    } catch (error) {
      console.error("Error Occurred While Fetching GetRawByAsset data", error);
      return [];
    }
  };
  const getAssetMappings = async (assetId) => {
    try {
      return await sbaAxios({ url: GetAssetMappings + "?assetId=" + assetId });
    } catch (error) {
      console.error("Error Occurred While Fetching GetAssetMappings data", error);
      return [];
    }
  };

  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
  };
  const updateWeight = async (passdata) => {
    try {
      if (!passdata?.AnalystExposureId) {
        SBNotify({ Msg: "Please Select Analyst", type: "error" });
        return;
      }
      if (!passdata?.RawExposureId) {
        SBNotify({ Msg: "Please Select  Raw", type: "error" });
        return;
      }
      if (!passdata?.ExposureWeight) {
        SBNotify({ Msg: "Please Enter Weight", type: "error" });
        return;
      }
      const data = {
        AssetExposureMappingId: passdata?.AssetExposureMappingId,
        AssetId: parseInt(params.Asset),
        AnalystExposureId: passdata?.AnalystExposureId,
        RawExposureId: passdata?.RawExposureId,
        ExposureWeight: passdata?.ExposureWeight,
        ModifiedBy: 0
      };
      const res = await sbaAxios({ url: InsertUpdateAssetMapping, method: "post", data });
      SBNotify({ Msg: "Asset Mapping Updated Successfully" });
      setSelectedMapping(null);
      fetchRaw(parseInt(params.Asset));
      fetchAssetMapping(parseInt(params.Asset));
      setMappingDrawer(false);
    } catch (error) {
      console.error("Error adding weight:", error);
      SBNotify({ msg: "Some Exception Occurred. Please Contact Admin", type: "error" });
    }
  }
  const deleteAssetMapping=async(id)=>{
    try {
     await sbaAxios({url:DeleteAssetMapping+"?AssetExposureMappingId="+id})
     SBNotify({Msg:"Selected Mapping Deleted Successfully"});
     fetchRaw(parseInt(params.Asset));
     fetchAssetMapping(parseInt(params.Asset));
    } catch (error) {
      SBNotify({Msg:"Some Exception occured , Please Contact Admin" , type:"error"})
    }
  }
  const ActionsRenderer = (props) => {

    return (
      <div className="actions-cell">
        <i className="fas fa-edit text-success mx-2 SBA_hand" onClick={() => {
          setSelectedMapping(props.data);
          setMappingDrawer(true);
        }}></i>
        <i className="fa fa-trash text-danger mx-2 SBA_hand" onClick={() => {
          deleteAssetMapping(props.data.AssetExposureMappingId);
         
        }}></i>
      </div>)

  };
  const ColumnDefs = [
    {
      headerName: "AnalystExposure",
      field: "AnalystExposure",
      minWidth: 100,
    },
    {
      headerName: "RawExposure",
      field: "RawExposure",
      minWidth: 100,
    },
    {
      headerName: "ExposureWeight",
      field: "ExposureWeight",
      minWidth: 100,
    },
    {
      field: "Action",
      cellRenderer: ActionsRenderer,
      maxWidth: 100,
    }
  ];
  const addWeight = async () => {
    setMappingDrawer(true);
    setSelectedMapping({
      AssetExposureMappingId: 0,
      AssetId: 0,
      AnalystExposureId: 0,
      RawExposureId: 0,
      ExposureWeight: 0,
      RawExposure:"",
      AnalystExposure:"",
      ModifiedBy: 0
    });
   
  };

  return <>
    <div className="row">
      <div className="col-6">
        <label className="mb-1 ms-2 fw-semibold fs-12">Asset</label>
        <div>
          <SBAComboBox
            filterable={true}
            data={AssetListData}
            textField="AssetName"
            valueField="AssetId"
            value={currentAsset}
            onChange={AssestDDChanged}
          />
        </div>
      </div>
      <div className="col-6 d-flex row-items justify-content-end">
        <button className="p-sm-btn" onClick={() => { addWeight() }}>Add</button>
      </div>
    </div>
    <div
      className="ag-theme-alpine"
      style={{ width: "100%", height: "500px" }}
    >
      <AgGridReact
        columnDefs={ColumnDefs}
        rowData={assetMappings}
        defaultColDef={defaultColDef}
      />
    </div>
    <SBADrawer open={mappingDrawer} setOpen={setMappingDrawer} title={selectedMapping?.AssetExposureMappingId>0 ? "Update Mapping" : "Insert Mapping"}>
    <div className="col-8 my-2">
        <label className="mb-1 ms-2 fw-semibold fs-12">Analyst </label>
        <div>
          <SBAComboBox
            filterable={true}
            data={analystType}
            textField="AnalystExposure"
            valueField="AnalystExposureId"
            value={selectedMapping}
            disabled={selectedMapping?.AssetExposureMappingId>0}
            popupSettings={{ className: "modalDD" }}
            onChange={(e) => { if (e.value) { setSelectedMapping(val =>({...val,...e.value})) } }}
          />
        </div>
      </div>
      <div className="col-8 my-2">
        <label className="mb-1 ms-2 fw-semibold fs-12">Raw</label>
        <div>
          <SBAComboBox
            filterable={true}
            data={rawByAsset}
            textField="RawExposure"
            valueField="RawExposureId"
            value={selectedMapping}
            disabled={selectedMapping?.AssetExposureMappingId>0}
            popupSettings={{ className: "modalDD" }}
            onChange={(e) => { if (e.value) { setSelectedMapping(val =>({...val,...e.value})) } }}
          />
        </div>
      </div>
      <div className="col-8 my-2">
        <label className="mb-1 ms-2 fw-semibold fs-12">Weight</label>
        <div>
          <input type="number" className="form-control" value={selectedMapping?.ExposureWeight} onChange={(e) => { setSelectedMapping(val =>({...val,ExposureWeight:parseFloat(e?.target?.value) || 0}))  }} />
        </div>
      </div>
      <div className="col-8 d-flex justify-content-end my-2">
        <button className="s-sm-btn mx-2" onClick={()=>{setMappingDrawer(false)}}>Cancel</button>
        <button className="p-sm-btn mx-2" onClick={()=>{updateWeight(selectedMapping)}}> Save</button>
      </div>
    </SBADrawer>
  </>
}